import { combineReducers } from '@reduxjs/toolkit';
import legalDocSlice from "./slice/legalDoc/legalSlice"

// Combine slice reducers into a root reducer
const rootReducer = combineReducers({
  legalDoc:legalDocSlice,
});

export default rootReducer;